// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CaretRight from "@werner/XDL/Icons/CaretRight";
import { xBaseTheme } from "@werner/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        headerColor: "common.white",
        bodyColor: "common.white",
        mergeCss: true,
        childTypographyProps: {
            css: css`
                display: block;
                word-wrap: break-word;
                width: 100%;
            `,
        },
        backIconProps: { src: "ChevronLeft" },
        closeIconProps: { src: "X" },
        panelRowProps: {
            color: "common.ui3",
            moreIconProps: {
                src: CaretRight,
                size: 20,
                color: "common.ui3",
                css: css`
                    width: 100%;
                    justify-content: flex-end;
                `,
            },
        },
    },
} as xBaseTheme["panelMenu"];
